export default new RegExp(`([?!.'"])+$`, "g")
